// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.friends-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow-y: auto;
}

.friends-page .top-content .friends-page-title {
    font-weight: 600;
    font-size: 5.581vw;
    line-height: 6.512vw;
    letter-spacing: 2%;
    text-align: center;
    color: white;
}


.friends-page .top-content h5{
    font-weight: 300;
    font-size: 3.721vw;
    line-height: 4.419vw;
    letter-spacing: 2%;
    text-align: center;
    color: #FFFFFF4D;
}

.friends-page .link-row {
    display: flex;
    margin-top: 10vw;
    margin-bottom: 10vw;
}

.friends-page .link-row .link {
    display: block;
    width: 73.721vw;
    margin-right: 2.326vw;
    padding: 2.8vw;
    overflow: hidden;
    white-space: nowrap; 
    text-overflow: clip;
    font-weight: 600;
    font-size: 3.721vw;
    line-height: 4.44vw;
    letter-spacing: 2%;
    color: white;
}

.friends-page .link-row div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 10.93vw;
    height: 10.93vw;
    border-radius: 16px;
    background: linear-gradient(to right, #551D5E, #153A64);
    border: 1px solid linear-gradient(to bottom, #FFFFFF, #FFFFFF1C);
}

.friends-page .friends-page-main-text {
    font-weight: 600;
    font-size: 5.581vw;
    line-height: 6.512vw;
    letter-spacing: 2%;
    text-align: center;
    color: white;
    margin-bottom: 2vw;
}

.friends-page .friends-page-main-text-new {
  font-weight: 600;
  font-size: 2.79vw;
  line-height: 3.256vw;
  letter-spacing: 2%;
  text-align: center;
  color: white;
  margin-bottom: 2vw;
}

.table-container {
    width: 86.512vw;
    margin: auto;
    border-radius: 16px;
    overflow: hidden;
    background: linear-gradient(to bottom, #0d0f1a, #10121f);
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.4);
    margin-bottom: 4vw;
  }
  
  table {
    width: 100%;
    table-layout: fixed; /* Щоб усі колонки займали рівномірний простір */
    border-collapse: collapse;
  }

  td:first-child, th:first-child {
    max-width: 30vw; /* обмеження ширини стовпця з ім'ям */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  
  thead {
    background-color: #5d6dff;
    color: white;
    font-weight: bold;
  }
  
  th, td {
    padding: 2.791vw;
    text-align: center;
    font-size: 3.721vw;
    color: rgba(255, 255, 255, 0.9);
  }
  
  tbody tr {
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
  
  tbody tr:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
  
  tbody {
    background: rgba(255, 255, 255, 0.05);
  }
`, "",{"version":3,"sources":["webpack://./src/pages/friends/style/friends_page.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;;AAGA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,qBAAqB;IACrB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,mBAAmB;IACnB,uDAAuD;IACvD,gEAAgE;AACpE;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,wDAAwD;IACxD,2CAA2C;IAC3C,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,mBAAmB,EAAE,gDAAgD;IACrE,yBAAyB;EAC3B;;EAEA;IACE,eAAe,EAAE,qCAAqC;IACtD,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,0CAA0C;EAC5C;;EAEA;IACE,qCAAqC;EACvC","sourcesContent":[".friends-page {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    overflow-y: auto;\n}\n\n.friends-page .top-content .friends-page-title {\n    font-weight: 600;\n    font-size: 5.581vw;\n    line-height: 6.512vw;\n    letter-spacing: 2%;\n    text-align: center;\n    color: white;\n}\n\n\n.friends-page .top-content h5{\n    font-weight: 300;\n    font-size: 3.721vw;\n    line-height: 4.419vw;\n    letter-spacing: 2%;\n    text-align: center;\n    color: #FFFFFF4D;\n}\n\n.friends-page .link-row {\n    display: flex;\n    margin-top: 10vw;\n    margin-bottom: 10vw;\n}\n\n.friends-page .link-row .link {\n    display: block;\n    width: 73.721vw;\n    margin-right: 2.326vw;\n    padding: 2.8vw;\n    overflow: hidden;\n    white-space: nowrap; \n    text-overflow: clip;\n    font-weight: 600;\n    font-size: 3.721vw;\n    line-height: 4.44vw;\n    letter-spacing: 2%;\n    color: white;\n}\n\n.friends-page .link-row div {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 10.93vw;\n    height: 10.93vw;\n    border-radius: 16px;\n    background: linear-gradient(to right, #551D5E, #153A64);\n    border: 1px solid linear-gradient(to bottom, #FFFFFF, #FFFFFF1C);\n}\n\n.friends-page .friends-page-main-text {\n    font-weight: 600;\n    font-size: 5.581vw;\n    line-height: 6.512vw;\n    letter-spacing: 2%;\n    text-align: center;\n    color: white;\n    margin-bottom: 2vw;\n}\n\n.friends-page .friends-page-main-text-new {\n  font-weight: 600;\n  font-size: 2.79vw;\n  line-height: 3.256vw;\n  letter-spacing: 2%;\n  text-align: center;\n  color: white;\n  margin-bottom: 2vw;\n}\n\n.table-container {\n    width: 86.512vw;\n    margin: auto;\n    border-radius: 16px;\n    overflow: hidden;\n    background: linear-gradient(to bottom, #0d0f1a, #10121f);\n    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.4);\n    margin-bottom: 4vw;\n  }\n  \n  table {\n    width: 100%;\n    table-layout: fixed; /* Щоб усі колонки займали рівномірний простір */\n    border-collapse: collapse;\n  }\n\n  td:first-child, th:first-child {\n    max-width: 30vw; /* обмеження ширини стовпця з ім'ям */\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n  }\n  \n  thead {\n    background-color: #5d6dff;\n    color: white;\n    font-weight: bold;\n  }\n  \n  th, td {\n    padding: 2.791vw;\n    text-align: center;\n    font-size: 3.721vw;\n    color: rgba(255, 255, 255, 0.9);\n  }\n  \n  tbody tr {\n    border-top: 1px solid rgba(255, 255, 255, 0.1);\n  }\n  \n  tbody tr:hover {\n    background-color: rgba(255, 255, 255, 0.1);\n  }\n  \n  tbody {\n    background: rgba(255, 255, 255, 0.05);\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
